import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { Button } from '@components/Button';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  position: relative;
  display: flex;
  height: 45vw;
  min-height: var(--sectionMinHeight);
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
`;

export const TextWrapperBox = styled(Box)`
  position: absolute;
  width: 100%;
  top: 9vw;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const StyledText = styled(Text)`
  text-align: center;
  margin-bottom: ${themeSpace(7)};
`;

export const StyledButton = styled(Button)`
  margin: auto;
  display: block;
  width: fit-content;
`;
